module.exports = __webpack_public_path__ + "static/media/lag_wtf.3da2ae8a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Lag/images/animations/lag_wtf.mp4
// module id = 1485
// module chunks = 39